"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagIconV2 = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const IconContext_1 = require("../Icon/IconContext");
const FlagIconV2 = (_a) => {
    var { size = "md", sx, flag } = _a, restProps = __rest(_a, ["size", "sx", "flag"]);
    const { getIconComponent, cacheIconComponent } = (0, IconContext_1.useIconCache)();
    const FlagIconVariant = getIconComponent(flag);
    react_1.default.useEffect(() => {
        cacheIconComponent(flag, FlagIconVariant);
    }, [flag, FlagIconVariant, cacheIconComponent]);
    // @ts-ignore - for borderRadius values
    const iconStyle = react_1.default.useMemo(() => {
        switch (size) {
            case "xs":
                return {
                    width: "spacing-5",
                    height: "spacing-4",
                    borderRadius: ".75px"
                };
            case "sm":
                return {
                    width: "spacing-7",
                    height: "spacing-6",
                    borderRadius: "1px"
                };
            case "lg":
                return {
                    width: "spacing-9",
                    height: "spacing-8",
                    borderRadius: "2px"
                };
            case "xl":
                return {
                    width: "spacing-10",
                    height: "spacing-9",
                    borderRadius: "3px"
                };
            default:
                return {
                    width: "spacing-8",
                    height: "spacing-7",
                    borderRadius: "1.5px"
                };
        }
    }, [size]);
    return (react_1.default.createElement(__1.Box, Object.assign({ as: "span", sx: Object.assign(Object.assign({ display: "inline-flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }, iconStyle), sx) }, restProps),
        react_1.default.createElement(FlagIconVariant, null)));
};
exports.FlagIconV2 = FlagIconV2;
//# sourceMappingURL=FlagIcon.js.map